/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { CreatedCryptoLink } from './CreatedCryptoLink'
import {
  CreatedCryptoLinkFromJSON,
  CreatedCryptoLinkFromJSONTyped,
  CreatedCryptoLinkToJSON,
} from './CreatedCryptoLink'

/**
 *
 * @export
 * @interface CreateCryptoLink200Response
 */
export interface CreateCryptoLink200Response {
  /**
   *
   * @type {boolean}
   * @memberof CreateCryptoLink200Response
   */
  status: boolean
  /**
   *
   * @type {CreatedCryptoLink}
   * @memberof CreateCryptoLink200Response
   */
  data: CreatedCryptoLink
}

/**
 * Check if a given object implements the CreateCryptoLink200Response interface.
 */
export function instanceOfCreateCryptoLink200Response(
  value: object
): value is CreateCryptoLink200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CreateCryptoLink200ResponseFromJSON(
  json: any
): CreateCryptoLink200Response {
  return CreateCryptoLink200ResponseFromJSONTyped(json, false)
}

export function CreateCryptoLink200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateCryptoLink200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: CreatedCryptoLinkFromJSON(json['data']),
  }
}

export function CreateCryptoLink200ResponseToJSON(
  value?: CreateCryptoLink200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: CreatedCryptoLinkToJSON(value['data']),
  }
}
